export default __webpack_public_path__ + "static/media/misc-makeupA-1440w.73a4c3b2.avif";